import store from "@/store"
import i18n from "@/locale/index"
export const optionalChaining = (obj, ...rest) => {
  let tmp = obj
  for (let key in rest) {
    let name = rest[key]
    tmp = tmp?.[name]
  }
  return tmp ?? null
}

export const withCommas = num => {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","))
}

// let data = this.$options.filters.dayUnit(10)
// let temp = Vue.filters("dayUnit")(1000)
// console.log(temp, this.spaceApplicationOptions)
export const dayUnit = (num = 0) => {
  return num + " " + (num > 1 ? i18n.t("index").label.Days : i18n.t("index").label.Day)
}

export const capacityUnit = (val, type = 1) => {
  return !!type ? `${val} (${store.getters["projectPre/capacityUnit"].name})` : !val && val !== 0 ? "--" : `${val} ${store.getters["projectPre/capacityUnit"].name}`
}

export const KWUnit = (val, type = 1) => {
  return !!type ? `${val} (kW)` : !val && val != 0 ? "--" : `${val} kW`
}

export const cvUnit = val => {
  return `${val} (MJ / ${store.getters["projectPre/energyType"]?.unit})`
}

export const waterUnit = val => {
  return `${val} (${i18n.t("index").label.liters} / ${i18n.t("index").label.day})`
}

export const priceUnit = val => {
  return `${val} (${store.getters["projectPre/currency"]?.symbol} / kWh)`
}

export const consumptionUnit = val => {
  return `${val} (${store.getters["projectPre/energyType"]?.unit})`
}

export const formatDateTime = (data, format = "yyyy-mm-dd") => {
  let date = typeof data === "number" ? new Date(data) : data
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, "0")
  const day = date.getDate().toString().padStart(2, "0")
  const hour = date.getHours().toString().padStart(2, "0")
  const minute = date.getMinutes().toString().padStart(2, "0")
  const second = date.getSeconds().toString().padStart(2, "0")

  return format.replace("yyyy", year).replace("mm", month).replace("dd", day).replace("hh", hour).replace("MM", minute).replace("ss", second)
}

export const numToFixed = (num, digits = 0) => {
  if (!isNumeric(num)) return num
  const strNum = num.toString()
  const decimalPart = strNum.split(".")[1]
  return !decimalPart || decimalPart.length <= digits ? num : parseFloat(num.toFixed(digits))
}

export const isNumeric = value => {
  if (typeof value === "number" && !isNaN(value)) return true

  if (typeof value === "string") {
    if (value.trim() === "") return false
    return /^[-+]?(\d+\.?\d*|\.\d+)$/.test(value.trim())
  }
  return false
}

export const getDaysInMonth = year => {
  const daysInMonths = []
  for (let month = 0; month < 12; month++) {
    const days = new Date(year, month + 1, 0).getDate()
    daysInMonths.push(days)
  }
  return daysInMonths
}

// export const isObjectEmpty = obj => {
//   for (var key in obj) {
//     if (obj.hasOwnProperty(key) && obj[key] !== null && obj[key] !== undefined && obj[key] !== "" && obj[key].length !== 0) {
//       return false
//     }
//   }
//   return true
// }

export const isObjectEmpty = obj => {
  if (typeof obj !== "object" || obj === null) return !obj

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key]

      if (Array.isArray(value))
        if (value.length === 0) continue
        else return false
      if (typeof value === "object" && value !== null) {
        if (!isObjectEmpty(value)) return false
      } else if (value !== null && value !== undefined && value !== "") {
        return false
      }
    }
  }
  return true
}
export const deepMerge = (target, source) => {
  if (typeof target !== "object" || target === null || typeof source !== "object" || source === null) {
    return source
  }
  if (source instanceof Date || source instanceof RegExp) {
    return source
  }

  const merged = Array.isArray(target) ? [...target] : { ...target }

  for (const key of Reflect.ownKeys(source)) {
    if (Object.hasOwn(source, key)) {
      const sourceVal = source[key]
      const targetVal = merged[key]

      if (Array.isArray(sourceVal) && Array.isArray(targetVal)) {
        merged[key] = [...sourceVal]
      } else if (typeof sourceVal === "object" && sourceVal !== null) {
        merged[key] = deepMerge(targetVal, sourceVal)
      } else {
        merged[key] = sourceVal
      }
    }
  }

  return merged
}



// WEBPACK FOOTER //
// ./src/utils/filters.js